import { useAdvanceSoon } from "../flow/useAdvanceSoon";
import { useFlow } from "../flow/FlowContext";
import { INTENT_OPTIONS } from "../flow/steps";
import { useT } from "../i18n";

function intentMessageKey(id: string): string {
  return id === "not-casual" ? "notCasual" : id;
}

export function IntentScreen() {
  const { answers, setIntent, next } = useFlow();
  const t = useT();
  const advance = useAdvanceSoon(next);

  return (
    <div className="prompt screen-enter">
      <header className="screen-head">
        {t("intent.eyebrow") ? (
          <div className="screen-head__eyebrow">{t("intent.eyebrow")}</div>
        ) : null}
        <h1 className="screen-head__title">{t("intent.title")}</h1>
        {t("intent.text") ? <p className="screen-head__text">{t("intent.text")}</p> : null}
      </header>
      <ul className="intent-options">
        {INTENT_OPTIONS.map((opt) => {
          const key = intentMessageKey(opt.id);
          const description = t(`intent.${key}.description`);
          return (
            <li key={opt.id}>
              <button
                type="button"
                className={answers.intent === opt.id ? "is-selected" : ""}
                onClick={() => {
                  setIntent(opt.id);
                  advance();
                }}
              >
                <strong>{t(`intent.${key}.label`)}</strong>
                {description ? <span>{description}</span> : null}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
